import { useEffect } from "react";
import { useLocation } from "react-router";
import { isAdminContext } from "util/MagnoliaAppHelpers";

/**
 * Component that redirects to Magnolia AdminCentral when:
 * - The domain contains "admin" (e.g., admin.albis.com)
 * - No mgnlPreview query parameter is present
 * 
 * This ensures that users accessing the admin domain without preview mode
 * are automatically redirected to the Magnolia admin interface.
 */
const AdminRedirect = () => {
  const location = useLocation();

  useEffect(() => {
    // Only redirect if we're on an admin domain
    if (!isAdminContext()) {
      return;
    }

    // Don't redirect if mgnlPreview is present (user is in preview/editor mode)
    if (location.search.includes("mgnlPreview")) {
      return;
    }

    // Redirect to Magnolia AdminCentral
    console.log("[Admin Redirect] Redirecting to AdminCentral");
    window.location.href = "/.magnolia/admincentral";
  }, [location]);

  return null;
};

export default AdminRedirect;

